<!-- 批量修改溯源码 -->
<template>
    <div class="container">
        <!-- 筛选条件 -->
        <div class="content section-filter">
            <div class="section-header">
                <Icon type="ios-search-outline" size="20" />
                <span>筛选条件</span>
                <span class="section-tip">（选择要修改的溯源码范围）</span>
            </div>
            <Form :model="form_data" label-position="right" :label-width="120">
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="选择批次：">
                            <Select
                                class="w200"
                                v-model="form_data.batch_id"
                                clearable
                                filterable
                                placeholder="请选择批次"
                            >
                                <Option
                                    v-for="item in batchList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.batch_name }}</Option
                                >
                            </Select>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon
                                    class="cursor-p ml8"
                                    type="md-help-circle"
                                    size="18"
                                />
                                <div slot="content">
                                    <p>选择批次，没有请先在【批次管理】中【新增批次】</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="选择产品：">
                            <Select
                                class="w200"
                                v-model="form_data.product_id"
                                clearable
                                filterable
                                placeholder="请选择产品"
                            >
                                <Option
                                    v-for="item in productList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.product_name }}</Option
                                >
                            </Select>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon
                                    class="cursor-p ml8"
                                    type="md-help-circle"
                                    size="18"
                                />
                                <div slot="content">
                                    <p>选择关联的产品，将会修改关联该产品的溯源码</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="选择经销商：">
                            <Select
                                class="w200"
                                v-model="form_data.agent_id"
                                clearable
                                filterable
                                placeholder="请选择经销商"
                            >
                                <Option
                                    v-for="item in agentList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.agent_name }}</Option
                                >
                            </Select>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon
                                    class="cursor-p ml8"
                                    type="md-help-circle"
                                    size="18"
                                />
                                <div slot="content">
                                    <p>选择默认所属的经销商，不选则暂时为空</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="12">
                        <FormItem label="ID号段：">
                            <Input
                                class="w120"
                                type="text"
                                v-model="form_data.start_id"
                                placeholder="起始ID"
                            ></Input>
                            <span class="ml8 mr8">至</span>
                            <Input
                                class="w120"
                                type="text"
                                v-model="form_data.end_id"
                                placeholder="截止ID"
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <!-- 修改数据 -->
        <div class="content section-edit">
            <div class="section-header">
                <Icon type="ios-create-outline" size="20" />
                <span>修改数据</span>
                <span class="section-tip">（留空则不修改对应字段）</span>
            </div>
            <Form :model="form_data" label-position="right" :label-width="120">
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="质保期：">
                            <Input
                                class="w200"
                                type="text"
                                v-model="form_data.warranty_days"
                                placeholder="请输入质保期"
                                ><span slot="append">天</span></Input
                            >
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="生产时间：">
                            <DatePicker
                                class="w200"
                                :value="form_data.productive_time"
                                type="date"
                                placeholder="点击选择时间"
                                @on-change="changeProductiveTime"
                            ></DatePicker>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="过期时间：">
                            <DatePicker
                                class="w200"
                                :value="form_data.expiration_date"
                                type="date"
                                placeholder="点击选择时间"
                                @on-change="changeExpirationDate"
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="关联批次：">
                            <Select
                                class="w200"
                                v-model="form_data.new_batch_id"
                                clearable
                                filterable
                                placeholder="模糊搜索批次名"
                                label-in-value
                                @on-change="changeNewBatch"
                            >
                                <Option
                                    v-for="item in batchList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.batch_name }}</Option
                                >
                            </Select>
                            <Tooltip max-width="300" placement="top" theme="light" transfer>
                                <Icon
                                    class="cursor-p ml8"
                                    type="md-help-circle"
                                    size="18"
                                />
                                <div slot="content">
                                    <p class="mb8">如果关联的批次不变，请留空。</p>
                                    <p class="theme-color">如果重新关联批次请跟产品对应修改，以免批次和产品关联对应混乱！</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="关联产品：">
                            <Select
                                class="w200"
                                v-model="form_data.new_product_id"
                                clearable
                                filterable
                                placeholder="模糊搜索产品名称"
                                label-in-value
                                @on-change="changeNewProduct"
                            >
                                <Option
                                    v-for="item in productList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.product_name }}</Option
                                >
                            </Select>
                            <Tooltip max-width="300" placement="top" theme="light" transfer>
                                <Icon
                                    class="cursor-p ml8"
                                    type="md-help-circle"
                                    size="18"
                                />
                                <div slot="content">
                                    <p class="mb8">如果关联的产品不变，请留空。</p>
                                    <p class="theme-color">如果重新关联产品请跟批次对应修改，以免批次和产品关联对应混乱！</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem label="关联经销商：">
                            <Select
                                class="w200"
                                v-model="form_data.new_agent_id"
                                clearable
                                filterable
                                placeholder="模糊搜索经销商名称"
                                label-in-value
                                @on-change="changeNewAgent"
                            >
                                <Option
                                    v-for="item in agentList"
                                    :value="item.id"
                                    :key="item.id"
                                    >{{ item.agent_name }}</Option
                                >
                            </Select>
                            <Tooltip max-width="250" placement="top" theme="light" transfer>
                                <Icon
                                    class="cursor-p ml8"
                                    type="md-help-circle"
                                    size="18"
                                />
                                <div slot="content">
                                    <p>如果关联的经销商不变，请留空。</p>
                                </div>
                            </Tooltip>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="8">
                        <FormItem label="是否启用：">
                            <i-switch
                                v-model="form_data.status"
                                size="large"
                                true-color="var(--primary-color) "
                                :true-value="1"
                                :false-value="2"
                                @on-change="changeStatus"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>

        <!-- 提交按钮 -->
        <div class="footer">
            <Button
                class="theme-bc theme-default-color btn-submit"
                @click="submitForm"
                ><Icon type="ios-checkmark-circle-outline" size="18" /> 确认修改</Button
            >
        </div>
    </div>
</template>

<script>
import {
    qrcode_batch_edit,
    get_options,
} from "@/api/index";
export default {
    data() {
        return {
            form_data: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                status: 2,
                productive_time: "",
                warranty_days: "",
                expiration_date: "",
                start_id: "",
                end_id: "",
                new_batch_id: "",
                new_product_id: "",
                new_agent_id: "",
            },
            batchList: [],
            productList: [],
            agentList: [],
            new_batch_data: "",
            new_product_data: "",
            new_agent_data: "",
            status_data: false,
        };
    },
    mounted() {
        this.getOptions();
    },
    methods: {
        changeProductiveTime(e) {
            if (e) {
                this.form_data.productive_time = e;
            } else {
                this.form_data.productive_time = "";
            }
        },
        changeExpirationDate(e) {
            if (e) {
                this.form_data.expiration_date = e;
            } else {
                this.form_data.expiration_date = "";
            }
        },
        // 下拉
        getOptions() {
            get_options()
                .then((res) => {
                    this.productList = res.data.product;
                    this.batchList = res.data.batch;
                    this.agentList = res.data.agent;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        changeNewBatch(e) {
            if (e) {
                this.new_batch_data = e.label;
            }
        },
        changeNewAgent(e) {
            if (e) {
                this.new_agent_data = e.label;
            }
        },
        changeNewProduct(e) {
            if (e) {
                this.new_product_data = e.label;
            }
        },
        changeStatus(e) {
           if(e){
                this.form_data.status = e;
                this.status_data = true;
           }
        },
        submitForm() {
            if (this.form_data.start_id * 1 > this.form_data.end_id * 1) {
                this.$Message.error("起始ID要小于截止ID");
                return;
            }
            var tip_data = "是否确认修改";
            if (this.form_data.new_batch_id) {
                tip_data =
                    tip_data + "，此次将会把批次修改为：" + this.new_batch_data;
            }
            if (this.form_data.new_product_id) {
                tip_data =
                    tip_data +
                    "，此次将会把产品修改为：" +
                    this.new_product_data;
            }
            if (this.form_data.new_agent_id) {
                tip_data =
                    tip_data + "，此次将会经销商修改为：" + this.new_agent_data;
            }
            this.$Modal.confirm({
                title: "提示",
                content: tip_data,
                onOk: () => {
                    if(this.status_data){
                        var data = {
                            batch_id: this.form_data.batch_id,
                            product_id: this.form_data.product_id,
                            agent_id: this.form_data.agent_id,
                            status: this.form_data.status,
                            productive_time: this.form_data.productive_time,
                            warranty_days: this.form_data.warranty_days,
                            expiration_date: this.form_data.expiration_date,
                            start_id: this.form_data.start_id,
                            end_id: this.form_data.end_id,
                            new_batch_id: this.form_data.new_batch_id,
                            new_product_id: this.form_data.new_product_id,
                            new_agent_id: this.form_data.new_agent_id,
                        }
                    }else {
                        var data = {
                            batch_id: this.form_data.batch_id,
                            product_id: this.form_data.product_id,
                            agent_id: this.form_data.agent_id,
                            productive_time: this.form_data.productive_time,
                            warranty_days: this.form_data.warranty_days,
                            expiration_date: this.form_data.expiration_date,
                            start_id: this.form_data.start_id,
                            end_id: this.form_data.end_id,
                            new_batch_id: this.form_data.new_batch_id,
                            new_product_id: this.form_data.new_product_id,
                            new_agent_id: this.form_data.new_agent_id,
                        }
                    }
                    qrcode_batch_edit(data)
                        .then((res) => {
                            this.form_data.batch_id = "";
                            this.form_data.product_id = "";
                            this.form_data.agent_id = "";
                            this.form_data.status = 2;
                            this.form_data.productive_time = "";
                            this.form_data.warranty_days = "";
                            this.form_data.expiration_date = "";
                            this.form_data.start_id = "";
                            this.form_data.end_id = "";
                            this.form_data.new_batch_id = "";
                            this.form_data.new_product_id = "";
                            this.form_data.new_agent_id = "";
                            this.status_data = false;
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}
.content {
    padding: 20px 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
/* 区块标题 */
.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 2px solid #f0f0f0;
    font-weight: 600;
    font-size: 16px;
    color: #333;
}
.section-header i {
    margin-right: 8px;
    color: #666;
}
.section-tip {
    margin-left: 8px;
    font-weight: normal;
    font-size: 13px;
    color: #999;
}
/* 筛选区块 */
.section-filter {
    border-left: 4px solid #19be6b;
}
.section-filter .section-header i {
    color: #19be6b;
}
/* 修改区块 */
.section-edit {
    border-left: 4px solid #ff6b00;
}
.section-edit .section-header i {
    color: #ff6b00;
}
.footer {
    padding: 20px 0;
    text-align: center;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.btn-submit {
    padding: 5px 40px;
    font-size: 15px;
}
.btn-submit i {
    margin-right: 6px;
}
.cursor-p {
    cursor: pointer;
}
.mb8 {
    margin-bottom: 8px;
}
.ml8 {
    margin-left: 8px;
}
.mr8 {
    margin-right: 8px;
}
.w120 {
    width: 120px;
}
.w200 {
    width: 200px;
}
</style>